<template>
  <div class="portlet_form">
    <div v-if="pageItem.homeCardTitleUseYn === 'Y'" class="portlet_tit">
      <h3 class="tt_tit">{{ pageItem.homeCardName }}</h3>
    </div>
    <div class="portlet_content">
      <!-- {{ pageItem.homeCardContent }} -->
      <container :is="currentComponent" :pageItem="pageItem"/>
    </div>
    <div class="portlet_bottom">
      <div class="left">
        <!--<sui-button type="button" class="btn_txt_GR_arrow">{{ $t('MSG_TXT_SHOW_DETAIL') }}</sui-button>-->
      </div>
      <div class="right">
       <span :class="pageItem.homeCardTypeCode === 'D' ? 'ico_dashboard' : 'ico_notice'">
         {{ pageItem.homeCardTypeName }}
       </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PGE_CMP_00016', // eslint-disable-line vue/name-property-casing
  props: {
    pageItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  mounted() {
    if (this.$props.pageItem.pageId) {
      const component = utils.getPageComponentById(this.$props.pageItem.pageId);
      if (component) {
        utils.loadPageMeta(this.$props.pageItem.pageId).then(() => {
          this.currentComponent = component;
        }).catch(error => {
          // do nothing;
          console.log(error);
        });
      }
    }
  },
};
</script>

<style scoped>
  .portlet_form {
    display:flex;
    flex-direction: column;
    width:312px;
    height:300px;
  }
  .portlet_tit {height:66px}
  .portlet_tit .tt_tit {
    margin:18px 28px 0 28px;
    font-size:16px;
    color: #333;
    font-weight:500;
    line-height:24px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .portlet_tit .sub_txt {
    margin:10px 28px;
    font-size:12px;
    color: #959595;
    line-height:24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 85%;
    display: inline-block;
  }
  .portlet_content {
    height:100%;
    overflow: auto;
  }
  .portlet_bottom {
    display:inline-flex;
    margin-top: auto;
    width:100%;
    line-height:40px;
  }
  .portlet_bottom .left{justify-content: flex-start;margin-left:28px;}
  .portlet_bottom .right {justify-content: flex-end;margin-left:auto;margin-right:28px}
  .btn_txt_GR_arrow  {
    font-size: 12px;
    color:#333;
    font-weight:normal;
    padding-right:10px;
    background:url('../../../../assets/images/ic_hyperling_blue_disable.png') no-repeat right 7px}
  .portlet_bottom .right .ico_todo {
    font-size:10px;
    color:#a5a5a5;
    padding-right:20px;
    width:16px;
    height:16px;
    background:url('../../../../assets/images/ic_todo_tag_off.png') no-repeat 98% 2px;
  }
  .portlet_bottom .right .ico_dashboard {
    font-size:10px;
    color:#a5a5a5;
    padding-right:20px;
    width:16px;
    height:16px;
    background:url('../../../../assets/images/ic_dashboard_tag_off.png') no-repeat 98% 2px;
  }
  .portlet_bottom .right .ico_notice {
    font-size:10px;
    color:#a5a5a5;
    padding-right:20px;
    width:16px;
    height:16px;
    background:url('../../../../assets/images/ic_notice_tag_off.png') no-repeat 98% 2px;
  }
</style>
